import Card from 'src/components/Card';
import Loader from 'src/components/Loader';

import { useParaPlacementsQuery } from './adminSetupApi';

const fmt = (d: string) => new Date(d).toLocaleDateString(undefined, { timeZone: 'UTC' });

const ParaPlacementsTable = () => {
  const { data, isFetching } = useParaPlacementsQuery();

  if (isFetching) return <Loader />;
  if (!data?.length) return <div className="text-neutral-300">No Para placements yet</div>;

  return (
    <div className="flex flex-col gap-2">
      {data.map((p) => (
        <Card key={p.id} className="grid grid-cols-2 gap-2 md:grid-cols-6">
          <div>
            <div className="text-neutral-400 typography-body-sm">Student</div>
            <div className="font-bold">{p.studentName}</div>
          </div>
          <div>
            <div className="text-neutral-400 typography-body-sm">Provider</div>
            <div className="font-bold">{p.providerName}</div>
          </div>
          <div>
            <div className="text-neutral-400 typography-body-sm">School</div>
            <div>{p.schoolName ?? '—'}</div>
          </div>
          <div>
            <div className="text-neutral-400 typography-body-sm">Year / dates</div>
            <div>
              {p.schoolYear} · {fmt(p.startDate)} – {fmt(p.endDate)}
            </div>
          </div>
          <div>
            <div className="text-neutral-400 typography-body-sm">Status</div>
            <div>
              {p.status ?? '—'} {p.isActive ? '(active)' : ''}
            </div>
          </div>
          <div>
            <div className="text-neutral-400 typography-body-sm">Pay / DOE</div>
            <div>
              ${p.payRate ?? '—'}/h {p.paymentMethod ? `· ${p.paymentMethod}` : ''} · DOE{' '}
              {p.doeInvoiceType ?? '—'} {p.doeRate != null ? `$${p.doeRate}/h` : ''}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default ParaPlacementsTable;
